import type { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

declare global {
  interface Window {
    newrelic: BrowserAgent;
  }
}

/**
 * A wrapper for NewRelic that works in both client and server environments.
 * Lazily loads the appropriate implementation when methods are called.
 */
const newrelic = new Proxy({} as BrowserAgent, {
  get: (_target) => {
    return () => {
      // For server-side
      if (typeof window === "undefined") {
        return import("newrelic");
      }
      return window.newrelic;
    };
  },
});

export default newrelic;
